import React from 'react';
import PropTypes from 'prop-types';

const SectionTitle = ({ children, className = 'text-xl font-bold mt-10' }) => {
  return (
    <h2 className={className}>
      {children}
    </h2>
  );
};

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default SectionTitle;
